import { TileLayer } from "react-leaflet";

const MapTile = () => (
    <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://map.osiss.ir/tile/{z}/{x}/{y}.png"
    />
)

export default MapTile;